import React from 'react';

export interface IMessage {
  message: string;
}

export type AddMessageType = (message: IMessage) => void;

const defaultValues: AddMessageType = () => {};

export const EDMessagesContext: React.Context<AddMessageType> =
  React.createContext(defaultValues);
